import jQuery from "jquery";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
(function ($) {
    var current_width = $(window).width(),
        map = "",
        zoom = 1.55,
        iniCenter = [15, 30],
        map_container = "taxation-price-map",
        mapHandle = "mapBurden";

    let initialMap = window.location.hash;
    if (initialMap) {
        initialMap = initialMap.replace("#", "");

        let tab = $(`#map-filters a[data-map-handle=${initialMap}]`);

        mapHandle = initialMap;
        $(`#map-filters li`).removeClass("active");
        $(tab).parent().addClass("active");

        if (initialMap == "all-data") {
            mapHandle = "mapBurden";
            $("#all-data").removeClass("d-none");
            $("#" + map_container + ", #map-legend").addClass("d-none");
        } else {
            mapHandle = initialMap;
            $("#all-data").addClass("d-none");
            $("#" + map_container + ", #map-legend").removeClass("d-none");
        }
    }

    window.initMap = function initMap(data) {
        if (current_width < 768) {
            zoom = 0;
            iniCenter = [-14.396, 23];
        }

        allDataHtml(data);
        setMapLegend();

        $(".taxtaion-price-map-tabs a").on("click", function (e) {
            let handle = $(e.currentTarget).data("map-handle");

            if (handle == "all-data") {
                $("#all-data").removeClass("d-none");
                $("#" + map_container + ", #map-legend").addClass("d-none");
            } else {
                mapHandle = handle;
                $("#all-data").addClass("d-none");
                $("#" + map_container + ", #map-legend").removeClass("d-none");
                $(".mapboxgl-popup-close-button").click();
            }

            $(".taxtaion-price-map-tabs li").removeClass("active");
            $(e.currentTarget).parent().addClass("active");

            modifyMap(mapHandle, data);

            // window.initMap(data);
        });

        mapboxgl.accessToken =
            "pk.eyJ1IjoidG9iYWNjb2ZyZWVraWRzIiwiYSI6IlQ3bEdmNW8ifQ.aFJ5TdySQqX7x4ecxAp3Ug";

        map = new mapboxgl.Map({
            container: map_container,
            style: "mapbox://styles/tobaccofreekids/cli11vgvq04k601qnejr38ff2",
            center: iniCenter,
            minZoom: zoom,
            projection: "mercator",
        });

        map.scrollZoom.disable();
        map.addControl(new mapboxgl.NavigationControl());
        map.addControl(new mapboxgl.FullscreenControl());
        map.on("load", function () {
            // Add a new source from our GeoJSON data and set the
            // 'cluster' option to true. GL-JS will add the point_count property to your source data.
            map.addSource("countries", {
                type: "vector",
                url: "mapbox://mapbox.country-boundaries-v1",
            });

            // Add a black outline around the polygon.
            if (!map.getLayer("fill-countries-with-laws")) {
                map.addLayer(
                    {
                        id: "fill-countries-with-laws",
                        type: "fill",
                        source: "countries",
                        filter: data["filterExpression"],
                        layout: {},
                        paint: {
                            "fill-color": data["colorExpression"][mapHandle],
                            "fill-opacity": 1,
                        },
                        "source-layer": "country_boundaries",
                    },
                    "admin-0-boundary"
                );
            }

            map.on("click", "fill-countries-with-laws", function (e) {
                let bbox = [
                    [e.point.x, e.point.y],
                    [e.point.x, e.point.y],
                ];

                let f = map.queryRenderedFeatures(bbox, {
                    layers: ["fill-countries-with-laws"],
                });
                if (f.length) {
                    showCountryClusterInfo(e, map, f, data); //topmost feature
                }
            });

            map.on("mouseover", "fill-countries-with-laws", function () {
                map.getCanvas().style.cursor = "pointer";
            });

            map.on("mouseleave", "fill-countries-with-laws", function () {
                map.getCanvas().style.cursor = "";
            });
        });
    };

    function modifyMap(mapHandle, data) {
        map.setFilter("fill-countries-with-laws", data["filterExpression"]);
        map.setPaintProperty(
            "fill-countries-with-laws",
            "fill-color",
            data["colorExpression"][mapHandle]
        );
        setMapLegend();
        map.resize();
    }

    function showCountryClusterInfo(e, map, features, data) {
        // var features = map.queryRenderedFeatures(e.point);
        var countryName = features[0].properties.name_en;
        if (countryName == "Palestinian Territories") {
            var countryName = "Palestine";
        }

        let popupMaxWidth = "240px !important";
        if (screen.width <= 768) {
            popupMaxWidth = "100% !important";
        }

        var countryDescription = "";
        var popUpCoordinates = [0, 0];
        var feature = data["features"][countryName];

        if (countryName == "Canada") {
            countryDescription = popUpCanada();
        } else {
            countryDescription = popUpTaxGapContent(feature, true);
            if (mapHandle == "mapBurden" || mapHandle == "mapBurdenCigs") {
                countryDescription = popUpTaxBurdenContent(feature);
            } else if (mapHandle == "mapPrice") {
                countryDescription = popUpPriceContent(feature);
            }
        }

        if (feature !== undefined) {
            if (screen.width > 768) {
                popUpCoordinates = feature.properties.coordinates.slice();
                while (Math.abs(e.lngLat.lng - popUpCoordinates[0]) > 180) {
                    popUpCoordinates[0] +=
                        e.lngLat.lng > popUpCoordinates[0] ? 360 : -360;
                }
            }

            new mapboxgl.Popup()
                .setLngLat(popUpCoordinates)
                .setHTML(
                    `
                    <div class='countryDetails ${mapHandle}'>
                        <h4>
                            ${countryName}
                            <strong class='year'>
                                ${feature.properties.year}
                            </strong>
                        </h4>
                        <div class='countryDescription'>
                            ${countryDescription}
                        </div>
                    </div>
                    `
                )

                .setMaxWidth(popupMaxWidth)
                .addTo(map);
        } else {
            map.flyTo({
                zoom: map.getZoom() + 1,
                center: e.lngLat,
            });
        }
    }

    function popUpCanada() {
        return '<table class="table table-striped taxation-price">\
          <tr>\
            <td class="text-center py-5"><strong><br><a href="/what-we-do/global/taxation-price/tax-gap-canada">View province or territory level data.</a><br><br></strong></td>\
          </tr></table>';
    }

    function popUpTaxGapContent(feature, isPopUp) {
        var comments = feature.properties.comments;

        let rows = getHtpRow(feature.properties);

        let table = `
        <table class='table table-striped taxation-price'>
            <thead>
                <tr>
                    <th class='text-center'></th>
                    <th class='text-center'><strong>Price <small>(Pack of 20)</strong></small></th>
                    <th class='text-center'><strong>Excise Tax</strong></th>
                    <th class='text-center'><strong>Tax Burden</strong></th>
                    <th class='text-center'><strong>Tax Gap</strong></th>
                </tr>
            </thead>
            <tbody>`;

        if (rows.hasRows) {
            table += `
                <tr>
                    <td><strong>Heated Tobacco<br/>Products</strong></td>
                    ${rows.htpRow}
                    <td 
                        rowspan='2'
                        class='tax-gap text-center p-0' 
                        style='background-color: ${
                            isPopUp ? feature.properties.color[mapHandle] : ""
                        };'
                    >
                    ${
                        rows.hasTaxGap
                            ? feature.properties.taxGap + "<br>pp"
                            : "N/A"
                    }
                    </td>
                </tr>
                <tr>
                    <td><strong>Cigarettes</strong></td>
                    ${rows.cigRow}
                </tr>
                `;
        } else {
            table += `
            <tr>
                <td><strong>Heated Tobacco<br/>Products</strong></td>
                <td class="text-center position-relative" rowspan='2' colspan="3">
                    <div class="label-format">No data on tax and price</div>
                </td>
                
                <td 
                    rowspan='2'
                    class='tax-gap text-center p-0' 
                    style='background-color: ${
                        isPopUp ? feature.properties.color[mapHandle] : ""
                    };'
                >
                    ${
                        rows.hasTaxGap
                            ? feature.properties.taxGap + "<br>pp"
                            : "N/A"
                    }
                </td>
            </tr>
            <tr><td><strong>Cigarettes</strong></td></tr>
            `;
        }
        table += `
        <tr>
            <td><strong>Heated tobacco products <br> defined in tax code?</strong></td>
            <td colspan='4'>
                <div>
                    ${feature.properties.HTPdefinedInTaxCode}
                </div>
            </td>
        </tr> 
        </tbody></table>
        `;
        if (comments) {
            table += `
            <div class='comments mt-3'>
                <strong>Comments: </strong>
                <small>${comments}</small>
            </div>    
            `;
        }
        return table;
    }

    function getHtpRow(el) {
        let hasTaxGap = true,
            hasRows = true,
            htpPrice = `
                <td class='text-right'>
                    <div>
                        ${el.priceHTP}
                        ${el.lcu} / <br> 
                        ${el.priceHTPEUR} $PPP
                    </div>
                </td>`,
            htpExcise = `
                <td class='text-right'>
                    <div>
                        ${el.exciseTaxHTP}
                        ${el.lcu} / <br> 
                        ${el.exciseTaxHTPEUR} $PPP
                    </div>
                </td>`,
            htpTax = `
                <td class='text-center'>
                    <div>
                        ${el.taxBurdenHTP}
                    </div>
                </td>
            `,
            cigPrice = `
                <td class='text-right'>
                    <div>
                        ${el.priceCigarettes}
                        ${el.lcu} / <br> 
                        ${el.priceCigarettesEUR} $PPP
                    </div>
                </td>`,
            cigExcise = `
                <td class='text-right'>
                    <div>
                        ${el.exciseTaxCigarettes}
                        ${el.lcu} / <br> 
                        ${el.exciseTaxCigarettesEUR}  $PPP
                    </div>
                </td>`,
            cigTax = `
                <td class='text-center'>
                    <div>
                        ${el.taxBurdenCigarettes}
                    </div>
                </td>
            `;

        if (
            el.priceHTP == el.priceHTPEUR &&
            el.priceCigarettes == el.priceCigarettesEUR &&
            el.priceHTP.startsWith("No data") 
        ) {
            hasRows = false;
        }

        if (el.priceHTP == el.priceHTPEUR && el.priceHTP.startsWith("No data")) {
            hasTaxGap = false;
            htpExcise = "";
            htpTax = "";
            htpPrice = `
            <td class="text-center position-relative" colspan='3'>
                <div class="label-format">${el.priceHTP}</div>
            </td>`;
        }

        if (el.priceCigarettes == el.priceCigarettesEUR && el.priceHTP.startsWith("No data")) {
            hasTaxGap = false;
            cigExcise = "";
            cigTax = "";
            cigPrice = `
            <td class="text-center position-relative" colspan='3'>
                <div class="label-format">${el.priceCigarettes}</div>
            </td>
            `;
        }

        if (el.exciseTaxHTP == el.exciseTaxHTPEUR && htpExcise) {
            hasTaxGap = false;
            htpExcise = `
            <td class="text-center position-relative">
                <div class="label-format">${el.exciseTaxHTP}</div>
            </td>`;
        }
        if (el.exciseTaxCigarettes == el.exciseTaxCigarettesEUR && cigExcise) {
            hasTaxGap = false;
            cigExcise = `
            <td class="text-center position-relative">
                <div class="label-format">${el.exciseTaxCigarettes}</div>
            </td>`;
            if ( el.priceHTP.startsWith("No data") ) {
                hasRows = false;
            }
        }

        return {
            hasTaxGap,
            hasRows,
            hasTaxGap,
            htpRow: htpPrice + htpExcise + htpTax,
            cigRow: cigPrice + cigExcise + cigTax,
        };
    }

    function popUpTaxBurdenContent(feature) {
        var output =
            "<table class='table table-striped taxation-price'>\
        <thead>\
          <tr>\
            <th class='text-center'></th>\
            <th class='text-center'><strong>Price <small>(Pack of 20)</strong></small></th>\
            <th class='text-center'><strong>Excise Tax</strong></th>\
            <th class='text-center'><strong>Tax Burden</strong></th>\
          </tr>\
        </thead>\
        <tbody>";
        if (mapHandle == "mapBurden") {
            output +=
                "<tr>\
          <td><strong>Heated Tobacco<br/>Products</strong></td>\
          <td class='text-right'><div>" +
                feature.properties.priceHTP +
                " " +
                feature.properties.lcu +
                " / " +
                feature.properties.priceHTPEUR +
                " $PPP</div></td>\
          <td class='text-right'><div>" +
                feature.properties.exciseTaxHTP +
                " " +
                feature.properties.lcu +
                " / " +
                feature.properties.exciseTaxHTPEUR +
                " $PPP</div></td>\
          <td class='tax-gap' style='background-color: " +
                feature.properties.color[mapHandle] +
                ";'>" +
                feature.properties.taxBurdenHTP +
                "%</td>\
        </tr></tbody>\
      </table>";
        }
        if (mapHandle == "mapBurdenCigs") {
            output +=
                "<tr>\
          <td><strong>Cigarettes</strong></td>\
          <td class='text-right'><div>" +
                feature.properties.priceCigarettes +
                " " +
                feature.properties.lcu +
                " / " +
                feature.properties.priceCigarettesEUR +
                " $PPP</div></td>\
          <td class='text-right'><div>" +
                feature.properties.exciseTaxCigarettes +
                " " +
                feature.properties.lcu +
                " / " +
                feature.properties.exciseTaxCigarettesEUR +
                " $PPP</div></td>\
          <td class='tax-gap'  style='background-color: " +
                feature.properties.color[mapHandle] +
                ";'>" +
                feature.properties.taxBurdenCigarettes +
                "%</td>\
        </tr></tbody>\
      </table>";
        }

        return output;
    }

    function popUpPriceContent(feature) {
        return (
            "<table class='table table-striped taxation-price'>\
        <thead>\
          <tr>\
            <th class='text-center'></th>\
            <th class='text-center'><strong>Price <small>(Pack of 20)</strong></small></th>\
            <th class='text-center'><strong>Excise Tax</strong></th>\
          </tr>\
        </thead>\
        <tbody>\
          <tr>\
            <td><strong>Heated Tobacco<br/>Products</strong></td>\
            <td class='text-right'><div>" +
            feature.properties.priceHTP +
            " " +
            feature.properties.lcu +
            " / " +
            feature.properties.priceHTPEUR +
            " $PPP</div></td>\
            <td class='text-right'><div>" +
            feature.properties.exciseTaxHTP +
            " " +
            feature.properties.lcu +
            " / " +
            feature.properties.exciseTaxHTPEUR +
            " $PPP</div></td>\
          </tr>\
          <tr>\
            <td><strong>Cigarettes</strong></td>\
            <td class='text-right'><div>" +
            feature.properties.priceCigarettes +
            " " +
            feature.properties.lcu +
            " / " +
            feature.properties.priceCigarettesEUR +
            " $PPP</div></td>\
            <td class='text-right'><div>" +
            feature.properties.exciseTaxCigarettes +
            " " +
            feature.properties.lcu +
            " / " +
            feature.properties.exciseTaxCigarettesEUR +
            " $PPP</div></td>\
          </tr>\
        </tbody>\
      </table>"
        );
    }

    function allDataHtml(data) {
        var countries = data["features"];
        let csvUrl = "taxation_data.csv";
        var output = `
            <div class="allData">
                <div class="row">
                    <div class="col-12 text-end mb-3 row-controls">
                        <a href="/exports/csv/${csvUrl}" class="me-4 link-light">
                            <i class="fa-solid fa-file-csv"></i> Download CSV
                        </a>
                        <a href="javascript:window.print();" class="link-light">
                            <i class="fa-solid fa-print"></i>Print
                        </a>
                    </div>`;
        $.each(countries, function (key, country) {
            let table = popUpTaxGapContent(country, false);

            if (country.properties.countryName == "Canada") {
                table = popUpCanada();
            }

            output += `
            <div class="col-lg-6 p-3">
                <div class="card p-3" style="height:100%">
                    <h4>
                        ${country.properties.countryName}
                        <strong class="year float-end">
                            ${country.properties.year}
                        </strong>
                    </h4>
                    ${table}
                </div>
            </div>
            `;
        });
        output += "</div></div>";

        $("#all-data").html(output);
    }

    function setMapLegend() {
        let legend = "";

        if (mapHandle == "mapBurden") {
            legend = `
                <h4>Excise Tax Burden: <br>HTPs</h4>
                <div>
                    <span style="background-color: #daebfb;"></span>Under 10%</div>
                <div>
                    <span style="background-color: #c8e0f9;"></span>10% to 15%</div>
                <div>
                    <span style="background-color: #a3cdf5;"></span>15% to 25%</div>
                <div>
                    <span style="background-color: #7ebaf1;"></span>25% to 40%</div>
                <div>
                    <span style="background-color: #7ebaf1;"></span>40% and over</div>
                <div>
                    <span style="background-color: #f5f5f5;">&nbsp;</span> No Data
                </div>
            `;
        } else if (mapHandle == "mapBurdenCigs") {
            legend = `
                <h4>Excise Tax Burden: <br>Cigarettes</h4>
                <div>
                    <span style="background-color: #faf9f0"></span>
                    Under 40%
                </div>
                <div>
                    <span style="background-color: #efecd2"></span>
                    40% to 50%
                </div>
                <div>
                    <span style="background-color: #dfd9a5"></span>
                    50% to 60%
                </div>
                <div>
                    <span style="background-color: #cec678"></span>
                    60% to 75%
                </div>
                <div>
                    <span style="background-color: #bdb246"></span>
                    75% and over
                </div>
                <div><span style="background-color: #f5f5f5;">&nbsp;</span> No Data</div>
            `;
        } else if (mapHandle == "mapPrice") {
            legend = `
                    <h4>Price ($PPP): <br>Heated tobacco products</h4>
                    <div><span style="background-color: #dafbfb">&nbsp;</span>Under 5 $PPP</div>
                    <div><span style="background-color: #b6f5f7">&nbsp;</span>5 to 6 $PPP</div>
                    <div><span style="background-color: #6bebef">&nbsp;</span>6 to 7 $PPP</div>
                    <div><span style="background-color: #17d7de">&nbsp;</span>7 to 8 $PPP</div>
                    <div><span style="background-color: #0f888d">&nbsp;</span>8 $PPP and over</div>
                    <div><span style="background-color: #f5f5f5;">&nbsp;</span> No Data</div>
                    <p class="mb-0" style="font-size: 0.95em;">$PPP = International Dollars</p>
                `;
        } else if (mapHandle == "mapGax") {
            legend = `
                <h4>Excise Tax Gap</h4>
                <div>
                    <span style="background-color: #fdf1ec"></span>
                    Under 10 pp
                </div>
                <div><span style="background-color: #f9d5c8"></span>
                    10 pp to 30 pp
                </div>
                <div><span style="background-color: #f6b8a2"></span>
                    30 pp to 40 pp
                </div>
                <div><span style="background-color: #f08e6a"></span>
                    40 pp to 50 pp
                </div>
                <div>
                    <span style="background-color: #eb6534"></span>
                    50 pp and over
                </div>
                <div>
                    <span style="background-color: #f5f5f5;"></span> No Data
                </div>
                <p class="mb-0" style="font-size: 0.95em;">pp = Percentage Points</p>
            `;
        }

        $("#map-legend").html(legend);
    }

    function dynamicSort(property) {
        var sortOrder = 1;

        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }

        return function (a, b) {
            if (sortOrder == -1) {
                return b[property].localeCompare(a[property]);
            } else {
                return a[property].localeCompare(b[property]);
            }
        };
    }

    //END OF INTERACTIVE LITIGATION MAP
    $(document).keyup(function (e) {
        if (e.keyCode === 27) $(".mapboxgl-popup-close-button").click();
    });
})(jQuery);
